import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'
// import ReactGA from 'react-ga4'
import { mouseflow } from 'react-mouseflow'
import TiktokPixel from 'tiktok-pixel'
declare global {
    interface Window {
        _mfq: any
    }
}
interface tracklead {
    email: string
    phone: string
}
interface argsInterface {
    fn: (...args: any) => any
}
export const HandleTracking = () => {
    let location = useLocation()
    // console.log('build tracking...', fbPixel)

    useEffect(() => {
        trackInitialization(location)
    }, [])

    useEffect(() => {
        trackPageViews(location.pathname)
    }, [location])

    // ReactPixel.track(event, data) // For tracking default events. More info about standard events: https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#standard-events
    // ReactPixel.trackSingle('PixelId', event, data) // For tracking default events.
    // ReactPixel.trackCustom(event, data) // For tracking custom events. More info about custom events: https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#custom-events
    // ReactPixel.trackSingleCustom('PixelId', event, data) // For
}

export const trackInitialization = (location: any) => {
    const subDomain = getSubdomain()
    console.log('initialise tracking: ', subDomain)

    switch (subDomain) {
        case 'itvpcp':
            // build_tracking('https://www.googletagmanager.com/gtag/js?id=GTM-W564KRL2')
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(['js', new Date()])
            window.dataLayer.push(['config', 'GTM-W564KRL26'])
            break
        default:
            // build_tracking('https://www.googletagmanager.com/gtag/js?id=GTM-W564KRL26')
            // window.dataLayer = window.dataLayer || []
            // window.dataLayer.push(['js', new Date()])
            // window.dataLayer.push(['config', 'GTM-W564KRL26'])

            break
    }
}

export const trackLead = ({ email, phone }: tracklead) => {
    const subDomain = getSubdomain()
    console.log('subdomain on track lead...', subDomain)
    switch (subDomain) {
        case 'itvpcp':
            gtag({ event: 'SubmitLead' })

            break

        default:
            // gtag({ event: 'SubmitLead' })
            break
    }
}

export const trackSubmitApplication = () => {
    const subDomain = getSubdomain()
    console.log('track submit application: ', subDomain)

    switch (subDomain) {
        case 'itvpcp':
            gtag({ event: 'SignedCFA' })
            break
        default:
            // gtag({ event: 'SignedCFA' })
            break
    }
}

export const trackCompleteRegistration = () => {
    const subDomain = getSubdomain()
    console.log('Complete registration: ', subDomain)

    switch (subDomain) {
        case 'itvpcp':
            gtag({ event: 'CompleteRegistration' })
            break

        default:
            // gtag({ event: 'CompleteRegistration' })
            break
    }
}

export const trackPageViews = (pathname: any) => {
    const subDomain = getSubdomain()
    switch (subDomain) {
        case 'itvpcp':
            gtag({ event: 'pageview', page: pathname })

            break
        default:
            // gtag({ event: 'pageview', page: pathname })
            break
    }
}

// const metaInit = () => {
//     const advancedMatching: any = {} // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
//     const options = {
//         autoConfig: true,
//         debug: false,
//     }
//     // ReactPixel.init('1651779192083119', advancedMatching, options) // miguel
//     // ReactPixel.init(fbPixel, advancedMatching, options)
//     console.log('FACEBOOK TRACK')
// }

// const tiktokInit = () => {
//     const advancedMatching = {
//         email: '',
//         phone_number: '',
//     }
//     const options = {
//         debug: false,
//     }
//     TiktokPixel.init('CPBJJLRC77U5G94V07AG', advancedMatching, options)
// }

// const gatherUTMS = (location: any) => {
//     /**
//      *
//      *
//         utm_source
//         utm_medium
//         utm_campaign
//         utm_content
//         um_id
//         utm_term
//      */
//     let paramsObj: any = {}
//     location.search
//         .replace('?', '')
//         .split('&')
//         .forEach((item: string) => {
//             let arr = item.split('=')
//             paramsObj[arr[0]] = arr[1]
//         })
//     const paramString = JSON.stringify(paramsObj)
//     if (!localStorage.getItem('utms') || paramString !== '{}') localStorage.setItem('utms', paramString)
// }

const build_tracking = (script_url: string) => {
    var s = document.getElementsByTagName('script')[0]
    var b = document.createElement('script')
    b.type = 'text/javascript'
    b.async = true
    b.src = script_url
    s.parentNode?.insertBefore(b, s)
}

const getSubdomain = () => {
    return window.location.href.replace('https://', '').split('.')[0]
}

function gtag(newData: any) {
    window.dataLayer.push(newData)
    console.log('DATA LAYER: ', window.dataLayer)
}
